import { OnboardingFlow } from '@mondaygpt/constants'

/**
 * State that can be passed via URL from the website to adjust onboarding behavior.
 *
 * Can be passed as:
 * 1. Base64-encoded JSON in `onboardingState` param: `/agents?onboardingState={b64-json}`
 * 2. Individual query params: `/agents?onboardingFlow=social&createFromTemplate=xyz`
 */
export interface OnboardingUrlState {
  /**
   * Which onboarding flow to use. Defaults to 'default' if not specified.
   * Each landing page can specify a different flow.
   */
  onboardingFlow?: OnboardingFlow

  /**
   * Template ID to create an agent from after onboarding completes
   */
  createFromTemplate?: string

  /**
   * Agent ID to duplicate after onboarding completes
   */
  duplicateAgent?: string
}

/**
 * URL search param keys for onboarding state
 */
export const ONBOARDING_STATE_PARAM = 'onboardingState'
export const ONBOARDING_PARAM_KEYS = {
  onboardingFlow: 'onboardingFlow',
  createFromTemplate: 'createFromTemplate',
  duplicateAgent: 'duplicateAgent',
} as const
